import React from 'react';
import { Text } from '@sonika-se/ui-kit/components';
export const RunningSchedulesDeleteShiftsWizardStep4 = (props) => {
    const { numShiftsToBeDeleted } = props;
    return numShiftsToBeDeleted !== null ? <Text>{numShiftsToBeDeleted} pass kommer tas bort</Text> : <Text>-</Text>;
};
export default RunningSchedulesDeleteShiftsWizardStep4;
